import { TUTORIAL_EXPORTING } from 'constants/tutorials';
import getTutorialCovers from './getTutorialCovers';

export default getTutorialCovers(TUTORIAL_EXPORTING);
